import React from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { size2Font } from "../../../utils/helpers";

export default function BIButton(args) {
  return (
    <Button {...args}>
      {args.loading ? (
        <CircularProgress color="inherit" size={size2Font(args.size)} />
      ) : (
        args.children
      )}
    </Button>
  );
}
